export default interface IDirectionData {
  id: string;
  name: string;
  order?: number
}

export class DirectionData implements IDirectionData {
  constructor(id: string, name: string, order?: number) {
    this.id = id;
    this.name = name;
    this.order = order
  }
  id: string;
  name: string;
  order: number
}

const defaultDirectionData = new DirectionData("", "", 0);
export { defaultDirectionData }